export const ROUTES = {
  HOME: '/',
  SEARCH: '/search',
  CATEGORY: '/:categorySlug',
  FAQ: '/faq',
  FAQ_ITEM: '/faq-item',
  ARTICLE: '/article',
  NOT_FOUND: '*',
};

export const API_URL = process.env.REACT_APP_API_URL || 'https://blog.vedmarket.ru/api';

export const MUI_LICENSE_KEY =
  '2eb6f9cda4e888996b232db3d18843e3Tz0xMjg0NjUsRT0xODA4NTI0Nzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=';

export const COLORS = {
  ORANGE: '#ED6C02',
  BLUE: '#3366FF',

  DARK: 'rgba(0, 0, 0, 0.87)',
  GRAY: '#E0E0E0',
  NEUTRAL_GRAY: '#ECEFF1',

  BEIGE: '#F5F5F5',
  DARK_GRAY: '#E0E0E0',
  MEDIUM_GRAY: '#666666',
  LIGHT_GRAY: 'rgba(0, 0, 0, 0.6)',
  VERY_LIGHT_GRAY: 'rgba(0, 0, 0, 0.4)',
  WHITE: '#FFF',
  WHITE_OPACITY: 'rgba(255, 255, 255, 0.6)',
  BLUE_GRAY: '#ECEFF1',

  GREEN: '#4CAF50',
  RED: '#DC2626',
  LIME: '#FFFDE7',

  BORDER_GRAY: 'rgba(0, 0, 0, 0.23)',
  STRONG_GRAY: '#BDBDBD',

  BLACK: 'rgba(0, 0, 0, 0.87)',
  BLACK_DARK: 'rgba(0, 0, 0, 1)',
  BLACK_MODAL: 'rgba(0, 0, 0, 0.9)',
  SLIGHTLY_GRAY: 'rgba(0, 0, 0, 0.12)',

  LIGHT_TEXT_SECONDARY: '#666666',
  LIGHT_TEXT_DISABLED: '#999999',
  LIGHT_TEXT_DISABLED_OPACITY: 'rgb(0, 0, 0, 0.26)',
  DARK_GRAY_TOOLTIP: 'rgba(97, 97, 97, 0.9)',
  YELLOW: '#FFB400',
  DARK_RED: '#D32F2F',
  BLUE_DARK: '#3399FF',
  GREEN_DARK: '#2E7D32',
  BLUE_PRIMARY_SHADES: 'rgba(25, 118, 210, 0.50)',


  WARNING: '#FF9800',
  LIGHT_BLUE: '#e6f3fa',
  LIGHT_BLUE_HOVER: 'rgba(25, 118, 210, 0.04)',
  BLUE_FOCUS: '#3366FF',
  BLUE_HEADER: '#0033CC',

  LIGHT_RED_OPACITY: 'rgba(211, 47, 47, 0.12)',
  LIGHT_BEIGE: '#FAFAFA',
  LIGHT_ACTION: 'rgb(0, 0, 0, 0.54)',

  GRAY_50: '#FAFAFA',
  LIGHT_OUTLINED_BORDER: 'rgb(0, 0, 0, 0.23)',
}
